import { useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { getMediaUrl, getProfileImage } from "../../utils/helpers";

const ratingItems = [
    {
        id: 1,
        title: "What are ratings and how do they work?",
        content:
            "After both public and private matches, we'll ask the user you were talking to to rate their conversation with you. The average of the score given by users will determine your rating score. When your rating is too low, you will face certain penalties.",
    },
    {
        id: 2,
        title: "Reduction of Earnings from Matches",
        content:
            "If your rating score is lower than 2, then you'll only be able to earn 30 coins/minute from your matches and 60 coins/minute from private calls. When your rating increases, this restriction will be removed, and you'll be able to continue earning 60 coins/minute from your matches and 120 coins/minute from private calls.",
    },
    {
        id: 3,
        title: "Not Showing on Explore",
        content:
            "If your rating score is lower than 2, then you won't be recommended to users in Explore mode, and since people cannot see you, the number of incoming calls to you might decrease. When your rating increases, this restriction will be removed, and you'll be once again recommended to users in Explore mode.",
    },
    {
        id: 4,
        title: "Account closure penalty",
        content:
            "If your rating score is lower than 2 and does not go above 2 again within a certain period of time, your account will be shut down and your coins will be erased.",
    },
];

export default function RatingScreen() {
    const [activeId, setActiveId] = useState(null);

    const user = useSelector((state) => state.auth.user);

    const toggleItem = (id) => {
        setActiveId(activeId === id ? null : id);
    };

    return (

        <div className="min-h-screen w-full bg-black flex justify-center">

            <div className="px-4 py-36 bg-black max-w-5xl mx-auto text-white">

                {/* RATING CARD */}
                <div className="bg-gradient-to-b from-[#1c1c1e] to-[#0e0e10] rounded-2xl p-6 shadow-lg">

                    {/* TOP STATUS */}
                    <div className="flex flex-col items-center mb-6 gap-2">
                        <img
                            src={getProfileImage(getMediaUrl(user?.ppImageURL))}
                            alt="profile"
                            className="w-16 h-16 rounded-full object-cover"
                            referrerPolicy="no-referrer"
                        />
                        <span className="text-white font-semibold text-sm">
                            {user?.name}
                        </span>
                    </div>

                    <div className="w-full flex items-center justify-between text-left mb-6">
                        <span className="font-medium">What is rank?</span>
                    </div>

                    {/* ACCORDION */}
                    <div className="divide-y divide-white/10">
                        {ratingItems.map((item) => {
                            const isOpen = activeId === item.id;

                            return (
                                <div key={item.id} className="py-4">

                                    {/* HEADER */}
                                    <button
                                        onClick={() => toggleItem(item.id)}
                                        className="w-full flex items-center justify-between text-left"
                                    >
                                        <span className="font-sm">{item.title}</span>

                                        <FaChevronRight
                                            className={`transition-transform duration-300 ${isOpen ? "rotate-90" : ""
                                                }`}
                                        />
                                    </button>

                                    {/* CONTENT */}
                                    <div
                                        onClick={() => toggleItem(item.id)}
                                        className={`overflow-hidden cursor-pointer transition-all duration-300 ${isOpen ? "max-h-40 mt-3" : "max-h-0"
                                            }`}
                                    >
                                        <p className="text-sm text-white leading-relaxed">
                                            {item.content}
                                        </p>
                                    </div>

                                </div>
                            );
                        })}
                    </div>

                </div>

            </div>
        </div>
    );
}